<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2">
        Notas fiscais -
        <span v-if="this.viewData.user">{{ this.viewData.user.name }}</span>
      </h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <div class="btn-group mr-2">
          <BaseButtonComponent
            @click="$bvModal.show('bv-modal-example')"
            variant="primary-action"
            >Enviar Nota Fiscal</BaseButtonComponent
          >
        </div>

        <b-modal id="bv-modal-example">
          <template v-slot:modal-title>Nova Nota Fiscal</template>

          <b-form>
            <error-container v-bind:errors="viewData.errors || []" />

            <b-form-group
              id="input-group-1"
              label="Descrição"
              label-for="input-1"
            >
              <b-form-textarea
                v-model="state.description"
                required
                placeholder="Informe a descrição"
                :state="isOk('description')"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <b-form-invalid-feedback>{{
                getError('description')
              }}</b-form-invalid-feedback>
            </b-form-group>

            <image-upload
              :currentUrl="this.state.photoUrl"
              :updateUrl="updateUrl"
              :setLoading="setLoadingPhoto"
              label="Arquivo: "
              extensions="pdf"
              accept="application/pdf"
              :isDoc="true"
            ></image-upload>
          </b-form>

          <template
            v-slot:modal-footer
            style="display: block; justify-content: flex-start"
          >
            <BaseButtonComponent
              style="float: left"
              @click="$bvModal.hide('bv-modal-example')"
              variant="secondary-action"
              >Fechar</BaseButtonComponent
            >

            <BaseButtonComponent
              style="float: right"
              v-if="!viewData.loadingDoc"
              @click="save"
              variant="primary-action"
              :disabled="!state.url || !state.description || viewData.saving"
            >
              <b-icon
                v-if="viewData.saving"
                icon="three-dots"
                animation="cylon"
              ></b-icon>
              <span v-else>Criar e Enviar Email</span>
            </BaseButtonComponent>
          </template>
        </b-modal>
      </div>
    </div>

    <b-row v-if="this.viewData.user">
      <b-col>
        <b-breadcrumb
          :items="[
            {
              text: 'Lista de Usuários',
              href: '/#/' + this.viewData.profile + 's',
            },
            {
              text: 'Notas Fiscais',
              href: '#',
              active: true,
            },
          ]"
        ></b-breadcrumb>
      </b-col>
    </b-row>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
      class="table-responsive d-flex justify-content-between flex-column h-100"
    >
      <table class="table b-table  table-hover table-bordered">
        <thead>
          <tr>
            <td>Data de Envio</td>
            <td>Nota</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ formatDate(item.createdAt) }}</td>
            <td>
              <a :href="item.url" target="_blank">{{
                item.description.length > 100
                  ? `${item.description.substring(0, 100)} ...`
                  : item.description
              }}</a>
            </td>
            <td style="text-align: right">
              <BaseButtonComponent
                @click="() => send(item)"
                size="sm"
                v-b-tooltip.hover
                title="Enviar Email"
                variant="secondary-action"
              >
                <b-icon icon="envelope" aria-hidden="true"></b-icon>
              </BaseButtonComponent>

              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import moment from 'moment-timezone';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'user-invoices',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        description: '',
        url: '',
      },
      viewData: {
        loading: true,
        saving: false,
        search: '',
        user: null,
        loadingDoc: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    this.viewData.profile = this.$route.params.profile;
    this.viewData.loading = true;

    try {
      const result = await API.post('/execute', {
        path: '/user/' + this.$route.params.id,
        method: 'get',
      });

      this.viewData.user = result.model;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
      return;
    }

    await this.getAll();

    this.viewData.loading = false;
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : '';
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1 },
      });
    },
    async getAll() {
      this.viewData.loading = true;
      try {
        const result = await API.post('/execute', {
          path:
            `/invoices/${this.$route.params.id}` +
            helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model };
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
      this.viewData.loading = false;
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.description}]?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/invoice/' + item.id,
          method: 'delete',
        });

        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async send(item) {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/invoice/' + item.id,
          method: 'put',
        });

        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingDoc = loading;
    },
    async save() {
      this.viewData.saving = true;

      try {
        const result = await API.post('/execute', {
          path: `/user/${this.$route.params.id}/invoice`,
          method: 'post',
          data: {
            description: this.state.description,
            url: this.state.url,
          },
        });
        this.$bvModal.hide('bv-modal-example');
        await this.getAll();
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }

      this.viewData.saving = false;
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
    BaseButtonComponent,
  },
};
</script>

<style>
.modal-footer {
  justify-content: flex-start;
  display: block;
}
</style>
